const JWT_KEY = "jwt";

export const getJwtToken = () => localStorage.getItem(JWT_KEY) || "";

export const saveJwtToken = async (token: string) => {
  localStorage.setItem(JWT_KEY, token);
};

export const clearJwtToken = async () => localStorage.removeItem(JWT_KEY);
